module.exports = __webpack_public_path__ + "media/images/country_flags/cw-03852c545683ef2896d3b0d3e5c14053.png";